import { defineMessages } from 'react-intl';

const scope = 'app.widgets.InventoryBlocks.components';

export default defineMessages({
    // Blocks global totals
    blockedRoomCountLabel: {
        id: `${scope}.StatisticsHeader.blockedRoomCount`,
        defaultMessage: 'Block',
    },
    pickedUpRoomCountLabel: {
        id: `${scope}.StatisticsHeader.pickedUpRoomCount`,
        defaultMessage: 'PU',
    },
    availableRoomCountLabel: {
        id: `${scope}.StatisticsHeader.availableRoomCount`,
        defaultMessage: 'Remaining',
    },
    revenueSoldLabel: {
        id: `${scope}.StatisticsHeader.revenueSold`,
        defaultMessage: 'Revenue',
    },
    estimatedRevenueTotalLabel: {
        id: `${scope}.StatisticsHeader.estimatedRevenueTotal`,
        defaultMessage: 'Est. Total',
    },
    // Block panel header
    roomCountLabel: {
        id: `${scope}.BlocksList.BlockItemHeader.Statistics.roomCountLabel`,
        description: 'Label describing number of rooms',
        defaultMessage: '{value} {value, plural, one {room} other {rooms}}',
    },
    fromToDate: {
        id: `${scope}.BlocksList.BlockItemHeader.dateRange.fromToDateLabel`,
        description: 'Label describing start & date of a block',
        defaultMessage: '{from} to {to}',
    },
    // Block panel details
    codeLabel: {
        id: `${scope}.BlocksList.BlockItemBody.details.code`,
        defaultMessage: 'Code',
    },
    createdDateTimeLabel: {
        id: `${scope}.BlocksList.BlockItemBody.details.createdDateTime`,
        defaultMessage: 'Created',
    },
    lastModifiedDateTimeLabel: {
        id: `${scope}.BlocksList.BlockItemBody.details.lastModifiedDateTime`,
        defaultMessage: 'Last Modified',
    },
    statusLabel: {
        id: `${scope}.BlocksList.BlockItemBody.details.status`,
        defaultMessage: 'Status',
    },
    // Allocations table headers
    dateColumnHeader: {
        id: `${scope}.BlocksList.BlockItemBody.table.header.date`,
        defaultMessage: 'Date',
    },
    roomsGroupColumnHeader: {
        id: `${scope}.BlocksList.BlockItemBody.table.header.rooms.groupColumn`,
        defaultMessage: 'Rooms',
    },
    roomsBlockedColumnHeader: {
        id: `${scope}.BlocksList.BlockItemBody.table.header.rooms.blocked`,
        defaultMessage: 'Block',
    },
    roomsSoldColumnHeader: {
        id: `${scope}.BlocksList.BlockItemBody.table.header.rooms.sold`,
        defaultMessage: 'PU',
    },
    roomsSoldColumnHeaderTooltip: {
        id: `${scope}.BlocksList.BlockItemBody.table.header.rooms.sold.tooltip`,
        defaultMessage: 'Picked up rooms',
    },
    roomsAvailableColumnHeader: {
        id: `${scope}.BlocksList.BlockItemBody.table.header.rooms.available`,
        defaultMessage: 'Rem.',
    },
    roomsAvailableColumnHeaderTooltip: {
        id: `${scope}.BlocksList.BlockItemBody.table.header.rooms.available.tooltip`,
        defaultMessage: 'Remaining rooms',
    },
    revenueGroupColumnHeader: {
        id: `${scope}.BlocksList.BlockItemBody.table.header.revenue.groupColumn`,
        defaultMessage: 'Revenue',
    },
    revenueSoldColumnHeader: {
        id: `${scope}.BlocksList.BlockItemBody.table.header.revenue.sold`,
        defaultMessage: 'PU',
    },
    revenueSoldColumnHeaderTooltip: {
        id: `${scope}.BlocksList.BlockItemBody.table.header.revenue.sold.tooltip`,
        defaultMessage: 'Picked up revenue',
    },
    revenueTotalColumnHeader: {
        id: `${scope}.BlocksList.BlockItemBody.table.header.revenue.total`,
        defaultMessage: 'Est.',
    },
    revenueTotalColumnHeaderTooltip: {
        id: `${scope}.BlocksList.BlockItemBody.table.header.revenue.total.tooltip`,
        defaultMessage: 'Estimated total revenue',
    },
    // Footer & CSV export
    exportLink: {
        id: `${scope}.footer.export.link`,
        defaultMessage: 'Export to CSV',
    },
    exportedFileName: {
        id: `${scope}.footer.export.filename`,
        defaultMessage: 'inventory-blocks',
    },
    csvHeaderCode: {
        id: `${scope}.footer.export.column.code`,
        defaultMessage: 'Code',
    },
    csvHeaderName: {
        id: `${scope}.footer.export.column.name`,
        defaultMessage: 'Name',
    },
    csvHeaderStartDate: {
        id: `${scope}.footer.export.column.startDate`,
        defaultMessage: 'Start date',
    },
    csvHeaderEndDate: {
        id: `${scope}.footer.export.column.endDate`,
        defaultMessage: 'End date',
    },
    csvHeaderSegment: {
        id: `${scope}.footer.export.column.segment`,
        defaultMessage: 'Segment',
    },
    csvHeaderStayDate: {
        id: `${scope}.footer.export.column.stayDate`,
        defaultMessage: 'Stay date',
    },
    csvHeaderBlockedRoomCount: {
        id: `${scope}.footer.export.column.blockedRoomCount`,
        defaultMessage: 'Block',
    },
    csvHeaderPickedUpRoomCount: {
        id: `${scope}.footer.export.column.pickedUpRoomCount`,
        defaultMessage: 'Pick up',
    },
    csvHeaderAvailableRoomCount: {
        id: `${scope}.footer.export.column.availableRoomCount`,
        defaultMessage: 'Remaining',
    },
    csvHeaderRevenueSold: {
        id: `${scope}.footer.export.column.revenueSold`,
        defaultMessage: 'Revenue',
    },
    csvHeaderEstimatedRevenueTotal: {
        id: `${scope}.footer.export.column.estimatedRevenueTotal`,
        defaultMessage: 'Estimated total',
    },
    csvHeaderStatus: {
        id: `${scope}.footer.export.column.status`,
        defaultMessage: 'Status',
    },
});
